var _rect, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobilePreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 2,
    width: 10,
    height: 20,
    rx: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 18,
    x2: 13,
    y2: 18
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePreviewIcon);
export default __webpack_public_path__ + "static/media/mobile-preview-icon.b2293ed40767ec0a71d402b4c8924118.svg";
export { ForwardRef as ReactComponent };